import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=75103875&scoped=true&"
import script from "./CategoryPage.vue?vue&type=script&lang=js&"
export * from "./CategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=75103875&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75103875",
  null
  
)

export default component.exports